<app-dc-pane
  [loading]="loading"
  [tableContainer]="true"
  [downloadSection]="true"
>
  <ng-container class="heading">
    <ng-container *ngIf="loading">Loading...</ng-container>
    <ng-container *ngIf="!loading">
      {{ pageTitle }}
      {{
        validationId?.createdDate
          | date: 'dd' + '/' + 'MM' + '/' + 'yyyy' + ' ' + 'HH' + ':' + 'mm'
      }}
    </ng-container>
  </ng-container>

  <ng-container class="download" *ngIf="rows && !loading">
    <app-dc-download-csv
      [csvData]="csvReadyData"
      [fileTitle]="csvSheetTitle"
      [noText]="true"
    ></app-dc-download-csv>
  </ng-container>

  <ng-container class="headingAction" *ngIf="!loading"
    ><div class="d-flex flex-nowrap">
      <app-dc-search
        *ngIf="rows && !loading"
        [formControl]="searchControl"
        [placeholder]="'Search'"
        (clearFilter)="clearSearchInput($event)"
        class="mr-2 align-self-center"
      ></app-dc-search>
      <div
        class="align-self-center text-nowrap {{
          selectedStatus !== 'all' ? 'selectedStatusActive' : ''
        }}"
      >
        <span
          *ngIf="countPass"
          title="Passed"
          class="badge badge-pill badge-success status-sm text-medium pl-2 pr-2 mr-2 {{
            selectedStatus == 'passed' ? 'selected' : ''
          }}"
          (click)="statusClick('passed')"
          role="button"
        >
          {{ countPass }}
        </span>
        <span
          *ngIf="countFail"
          title="Failed"
          class="badge badge-pill badge-danger status-sm text-medium pl-2 pr-2 mr-2 {{
            selectedStatus == 'failed' ? 'selected' : ''
          }}"
          (click)="statusClick('failed')"
          role="button"
        >
          {{ countFail }}
        </span>
        <span
          *ngIf="countTotal"
          title="Total"
          class="badge badge-pill status-sm text-medium pl-2 pr-2 mr-2 {{
            selectedStatus == 'all' ? 'selected' : ''
          }}"
          (click)="statusClick('all')"
          role="button"
        >
          {{ countTotal }}
        </span>
        <span
          class="badge badge-pill status-sm text-medium pl-3 pr-3"
          [class.badge-success]="ruleStatus === 'passed'"
          [class.badge-danger]="ruleStatus === 'failed'"
          style="opacity: 1"
          >{{ ruleStatus | titlecase }}</span
        >
      </div>
    </div></ng-container
  >
  <ng-container *ngIf="loading == false && rows?.length > 0">
    <app-dc-table
      [rows]="filteredRows"
      [columns]="columns"
      [messages]="messages"
      [sort]="sort"
    ></app-dc-table>
  </ng-container>
</app-dc-pane>
